import React from 'react';
import { workProcess } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const stepColors = [
  { num: 'text-[#7C3AED]', bg: 'bg-purple-50', border: 'border-purple-200' },
  { num: 'text-[#14B8A6]', bg: 'bg-teal-50', border: 'border-teal-200' },
  { num: 'text-[#7C3AED]', bg: 'bg-violet-50', border: 'border-violet-200' },
];

const ProcessStep = ({ step, index }) => {
  const anim = useScrollAnimation({ threshold: 0.2 });
  const colors = stepColors[index];

  return (
    <div
      ref={anim.ref}
      data-testid={`process-step-${step.id}`}
      className={`relative text-center scroll-fade-up scroll-delay-${index + 1} ${anim.isVisible ? 'scroll-visible' : ''}`}
    >
      <div className={`w-32 h-32 rounded-full ${colors.bg} border-2 ${colors.border} flex items-center justify-center mx-auto mb-6 relative z-10`}>
        <span className={`text-5xl font-black ${colors.num}`} style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          {step.step}
        </span>
      </div>
      <h3 className="text-xl font-bold tracking-tight text-zinc-900 mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
        {step.title}
      </h3>
      <p className="text-sm text-zinc-500 leading-relaxed max-w-xs mx-auto">
        {step.description}
      </p>
    </div>
  );
};

const HowWeWorkSection = () => {
  const header = useScrollAnimation({ threshold: 0.15 });

  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-zinc-50 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-[#7C3AED]/5 blur-[100px]" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] rounded-full bg-[#14B8A6]/5 blur-[80px]" />

      <div className="mx-auto w-full max-w-7xl px-4 md:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-20 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#14B8A6]/10 text-[#14B8A6] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide mb-4">
            OUR PROCESS
          </span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tight text-zinc-900 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            Three Steps to Registration
          </h2>
          <p className="text-base text-zinc-500 leading-relaxed">
            Our streamlined process removes the complexity from USPTO filing.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-0.5 bg-gradient-to-r from-[#7C3AED]/20 via-[#14B8A6]/20 to-[#7C3AED]/20" />
          {workProcess.map((step, index) => (
            <ProcessStep key={step.id} step={step} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
